import { fetchAPI } from "../config/api";
import { DEFAULT_YEAR } from "../config/constants";

export const fetchTeam = (teamId, signal) =>
  fetchAPI(`/api/team/${teamId}`, { signal });

export const fetchTeamGames = (teamId, signal) =>
  fetchAPI(`/api/team/${teamId}/games`, { signal });

export const fetchTeamStats = (teamId, statType, signal) =>
  fetchAPI(
    `/api/leaderboards/${statType}/${encodeURIComponent(teamId)}?start_year=2021&end_year=${DEFAULT_YEAR}`,
    { signal }
  );

export const fetchTeamPercentiles = (teamId, year, signal) =>
  fetchAPI(`/api/team-percentiles/${teamId}/${year}`, { signal });

export const fetchTeamLineupUsage = (teamId, year, signal) => {
  const yearParam = year ? `?year=${year}` : "";
  return fetchAPI(`/api/team/${teamId}/lineup-usage${yearParam}`, { signal });
};

export const fetchTeamPitcherUtilization = (teamId, year, signal) => {
  const yearParam = year ? `?year=${year}` : "";
  return fetchAPI(`/api/team/${teamId}/pitcher-utilization${yearParam}`, { signal });
};

export const fetchTeamRoster = (teamId, year, signal) => {
  const yearParam = year ? `?year=${year}` : "";
  return fetchAPI(`/api/team/${teamId}/roster${yearParam}`, { signal });
};
